// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    SCHEDULED_POSTS_RECEIVED: null,
    SINGLE_SCHEDULED_POST_RECEIVED: null,
    SCHEDULED_POST_UPDATED: null,
    SCHEDULED_POST_DELETED: null,
});
